module.exports = __webpack_public_path__ + "img/ubuntu-mono-light.369c8d21.png";